import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import axios from "axios";
import { Button, Form } from "semantic-ui-react";
import { getAuthHttpHeaders } from "../auth";
import { jsonError } from "../utils/jsonUtils";
import stringify, { sortObject } from "../utils/stringify";

@inject("store")
@observer
class AddEditBot extends Component {
  state = {
    type: this.props.botType ? this.props.botType : "BRUTUS",
    period: this.props.period ? this.props.period : 30,
    enabled: this.props.enabled !== undefined ? this.props.enabled : true,
    config: this.props.config ? stringify(sortObject(JSON.parse(this.props.config), null, 2)) : undefined,
    configJsonError: undefined,
  };

  submit = () => {
    const { configJsonError } = this.state;
    const { edit } = this.props;

    if (configJsonError) {
      alert("Config is not valid JSON:\n" + configJsonError);
      return;
    }

    if (edit) this.editBot();
    else this.addBot();
  };

  addBot = async () => {
    const { type, period, enabled, config } = this.state;
    const { exchangeAccountId } = this.props;

    let axiosRequest = axios.create({
      baseURL: "api",
      timeout: 30 * 1000,
      headers: {
        Accept: "application/json",
        ...getAuthHttpHeaders(),
      },
    });

    try {
      const response = await axiosRequest.post("botInstance/addBot", {
        type,
        period,
        enabled,
        config,
        exchangeAccountId,
      });

      if (response.data.errorMessage) alert("Config is invalid:\n" + response.data.errorMessage);
      else this.props.onSuccess();
    } catch (e) {
      alert(e);
    }
  };

  editBot = async () => {
    const { type, period, enabled, config } = this.state;
    const { editBotId } = this.props;

    let axiosRequest = axios.create({
      baseURL: "api",
      timeout: 30 * 1000,
      headers: {
        Accept: "application/json",
        ...getAuthHttpHeaders(),
      },
    });

    try {
      const response = await axiosRequest.post("botInstance/editBot", {
        type,
        period,
        enabled,
        config,
        botId: editBotId,
      });

      if (response.data.errorMessage) alert("Config is invalid:\n" + response.data.errorMessage);
      else this.props.onSuccess();
    } catch (e) {
      alert(e);
    }
  };

  render() {
    const { edit } = this.props;
    const { configJsonError } = this.state;

    const header = !edit ? <h3>New Bot</h3> : null;

    return (
      <div>
        <Form
          style={{
            margin: "10px",
          }}
          onSubmit={this.submit}
        >
          {header}
          <Form.Group inline>
            <Form.Field>
              <label>Type</label>
              <select required defaultValue={this.state.type} onChange={e => this.setState({ type: e.target.value })}>
                <option value="BRUTUS">Brutus</option>
                <option value="NEUROMANCER">Neuromancer</option>
              </select>
            </Form.Field>
            <Form.Field>
              <label>Period</label>
              <input
                defaultValue={this.state.period}
                type="number"
                required
                onChange={e => this.setState({ period: e.target.value })}
              />
            </Form.Field>
            <Form.Field>
              <label>Enabled</label>
              <input
                type="checkbox"
                defaultChecked={this.state.enabled}
                onChange={e => this.setState({ enabled: e.target.checked })}
              />
            </Form.Field>
          </Form.Group>
          <Form.Field>
            <label>Config</label>
            <textarea
              required
              placeholder="{}"
              onChange={({ target: { value } }) => this.setState({ config: value, configJsonError: jsonError(value) })}
              rows={25}
              style={{
                fontFamily: "monospace",
                color: configJsonError ? "red" : undefined,
              }}
              value={this.state.config}
            />
            {configJsonError && configJsonError.toString()}
          </Form.Field>

          <Button primary icon="checkmark" content="Submit" type="submit" />
          <Button icon="close" content="Close" onClick={this.props.onClose} />
        </Form>
      </div>
    );
  }
}

export default AddEditBot;



// WEBPACK FOOTER //
// ./src/bot/AddEditBot.js